import React from "react";
import Image from "@root/components/image";
import ResponsiveWrapper from "../_responsive-wrapper";

const CTA = ({ image, children }) => (
    <ResponsiveWrapper className="cta">
        <div className="cta__image-container">
            <Image image={image} alt="Call to Action" className="cta__image" />
        </div>
        <div className="cta__content">
            {children}
        </div>
    </ResponsiveWrapper>
);

export default CTA;
